import type { ErrorLike } from '@apollo/client';

import { useEvInterestUpdate } from '@features/EnergyTariffForm/hooks/useEvInterestUpdate';
import { useBundleBasket } from '@hooks/useBundleBasket';
import { useDeselectEnergy } from '@hooks/useEnergySelection';
import { useSnackbarError } from '@hooks/useSnackbarErrors';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';

const useClearSelectedProducts = () => {
  const { basketId } = useBasketContext();
  const { basketRaw } = useBundleBasket();
  const {
    deselectQuotes,
    loading: isDeselectingEnergyQuotes,
    reset,
  } = useDeselectEnergy();
  const { submitEvInterest, loading: isSubmittingEvInterest } =
    useEvInterestUpdate();
  const setSnackbarError = useSnackbarError(reset);

  const clearEnergy = () => {
    const promises = [];
    const energy = basketRaw?.energy;

    promises.push(deselectQuotes(basketId));

    if (energy?.details.electricVehicleTariffExpressionOfInterest) {
      promises.push(submitEvInterest(false, energy));
    }

    return promises;
  };

  const clearProducts = async () => {
    try {
      const promises = [...clearEnergy()];

      await Promise.all(promises);
    } catch (error) {
      setSnackbarError(error as ErrorLike);
      throw error;
    }
  };

  return {
    clearProducts,
    loading: isDeselectingEnergyQuotes || isSubmittingEvInterest,
  };
};

export { useClearSelectedProducts };
